export type ListDimensions = {
  height: number;
  width: number;
};

export const getContentDimensions = (
  listDimensions: ListDimensions | null,
  headerHeight: number
): ListDimensions | null => {
  if (!listDimensions) {
    return null;
  }

  return {
    ...listDimensions,
    height: Math.max(0, listDimensions.height - headerHeight),
  };
};
